
































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import { judgeDeviceType } from "@/utils/device";
import AiMoodPopup from './aiMoodPopup.vue';
import to from 'await-to-js';
import { newYearUrl } from '../utils/constant';

import {
  toast
} from '@/utils/util';

@Component({
  components: {
    AiMoodPopup
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class StepText extends Vue {
  @Prop({ default: '' })
  title: string;
  @Prop({ default: false })
  isNewYear: boolean;
  
  @Prop({ default: '' })
  defaultText: string;

  isApp = judgeDeviceType.isAPP;
  isSubmiting = false; // 正在生成中
  text: string = '';
  limitWordNum = 500; // 输入框最大字数
  placeHolder = '请输入或粘贴文案…(最少35字, 最多500字)'; // 输入框placeholder

  get commonPub() {
    return this.$store.getters['miguPage/getCommonPub'];
  }

  get textLength() {  // 输入框字数
    return this.text.trim().length
  }
  get pathSuffix() { return this.$publicPath + 'images/migu/' + (this.isNewYear ? 'newYear/' : ''); }
  get loadingIcon() { return this.pathSuffix + 'loading.png'; }

  // 获取最终的文本，提交用
  get submitParams() {
    return {
      text: this.text,
      wordLimit: this.limitWordNum,
    }
  }

  appDesDialog = false;
  mounted() {
    (window as any).getAppClipBordContent = this.getAppClipBordContent;
    this.getReferenceCopyList();
    const href = window.top.location.href;
    if (href.includes('notice')) {
      const notice = decodeURIComponent(href.split('notice=')[1]);
      localStorage.setItem('migu_notice', notice == '1'?'1':'0');
    }
    if (localStorage.getItem('migu_notice') == '1') {
      this.appDesDialog = true;
    }
  }
  @Watch('defaultText', { immediate: true })
  listenText(val) {
    if (val) {
      this.setText(val);
    }
  }

  // 提供给 app 的粘贴回调
  getAppClipBordContent(message: string) {
    message = decodeURI(message) || '';
    if (!message) return;
    this.setText(this.text + message);
  }
  // 点击粘贴按钮
  async pasteTxt() {
    if (this.isSubmiting) return;
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent;
      getClipBordContent.postMessage('');
    } else {
      try {
        const cptext = await navigator.clipboard.readText();
        this.setText(this.text + cptext);
      } catch (error) {
        toast("请点击输入框，长按粘贴内容");
        console.log('粘贴出错:', error);
      }
    }
  }

  // textarea 粘贴事件
  onPasteText(e) {
    try {
      e.preventDefault();  // 禁止默认事件，即粘贴的内容不放到文本框中
       // 获取剪贴板数据
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      this.setText(this.text + pastedData);
    } catch (error) {
      toast("请点击输入框，长按粘贴内容");
    }
  }
  onFocus() {
    this.isCollapse = false;
  }

  // 字数限制动画结束
  onAnimationend() {
    (this.$refs.textLengthRef as any).classList.remove('word-num-anim')
  }
  clear() {
    this.setText('');
  }

  rmSymbol(text) {
    if (!text) return ''
    const reg = /「|」|\[|\]|"|'|'|【|】|<|>/g
    text = text.replace(reg, '')
    return text
  }

  setText(str) {
    if (this.isSubmiting) return;
    let text = this.rmSymbol(str.trim());
    if (text.length > this.limitWordNum) {
      (this.$refs.textLengthRef as any).classList.add('word-num-anim');
      toast(`请输入${this.limitWordNum}字以内的文本，超出部分将自动截断`, 'top', 4000);
      text = text.substring(0, this.limitWordNum);
    }
    this.text = text;
  }

  // 参考文案
  referenceCopyList = []
  async getReferenceCopyList() {
    const [err, res] = await to(this.$http('getRandomText', { typeEnum: 'DIGITAL_READ', count: 5 }));
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    this.referenceCopyList = res.data || [];
  }

  addText(str) {
    this.setText(this.text + str);
  }

  // AI心语
  isShowAiMood = false;
  showAiMood() {
    if (!this.checkLogin()) return;
    this.isShowAiMood = true;
  }
  closeAiMood() {
    this.isShowAiMood = false;
  }
  setAiText(str) {
    this.setText(str);
    this.isCollapse = false;
  }

  // 检查登录
  checkLogin() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.$emit('check-login');
        return false;
      }
    }
    return true;
  }

  // 跳转创作记录页
  toWorksPage() {
    if (!this.checkLogin()) return;
    this.$router.push({
      path: '/migu-works',
    })
  }

  // 一键润色
  showLoading = false;
  async doExpand() {
    if (!this.checkLogin()) return;
    if (!this.text) {
      toast('请先输入或粘贴文案');
      return;
    }

    this.showLoading = true;
    // 提交任务
    const [expandError, expandRes] = await to(this.$http('expandInspiration', {
      content: this.text
    }));
    const expandData = expandRes && expandRes.data || {};
    const taskId = expandData.task_id
    if(expandError || !taskId) {
      this.showLoading = false;
      const message = expandData.message || (expandRes && expandRes.message);
      return toast(message || '生成失败');
    }

    this.getGenerateResult(taskId);
  }

  // 获取生成结果
  generateTimer = null;
  async getGenerateResult(id) {
    clearTimeout(this.generateTimer);
    const [expandError, expandRes] = await to(this.$http('getExpandResult', {
      taskId: id
    }));
    const expandData = expandRes && expandRes.data || {};

    if(expandData.status === 'waiting') {
      this.generateTimer = setTimeout(() => {
        this.getGenerateResult(id);
      }, 3000);
      return;
    }

    const resultText = expandData.results && expandData.results.results_list && expandData.results.results_list[0];
    if(expandError || expandData.status === 'fail' || !resultText) {
      const message = expandData.message || (expandRes && expandRes.message);
      this.showLoading = false;
      return toast(message || '生成失败');
    }

    this.setText(resultText);
    this.showLoading = false;
  }
  
  // 新春主题新增
  isCollapse = true; // 输入框是否折叠

  storyList = [
    {
      title: '新年故事',
      type: 'NEW_YEAR',
      icon: newYearUrl + 'icon1.png',
      iconActive: newYearUrl + 'icon1_active.png',
    },
    {
      title: '生肖故事',
      type: 'ZODIAC',
      icon: newYearUrl + 'icon2.png',
      iconActive: newYearUrl + 'icon2_active.png',
    },
    {
      title: '年画故事',
      type: 'NEW_YEAR_PIC',
      icon: newYearUrl + 'icon3.png',
      iconActive: newYearUrl + 'icon3_active.png',
    },
    {
      title: 'AI心语',
      icon: newYearUrl + 'icon4.png',
      iconActive: newYearUrl + 'icon4_active.png',
    },
  ];
  checkTab(item) {
    if (!this.checkLogin()) return;
    if(item.type) {
      this.getGenerateText(item.type);
    } else {
      this.showAiMood();
    }
  }
  // 获取故事创作文案
  async getGenerateText(typeEnum) {
    const [err, res] = await to(this.$http('getRandomText', { typeEnum, count: 1 }));
    if (err || res.code !== 200 || !res.data || !res.data.length) {
      return;
    }
    const textResult = res.data[0];
    this.setText(textResult);
    this.isCollapse = false;
  }
  desShow = false;
  showDialog() {
    this.desShow=true;
  }
}
